import { AlertRecipientsPanel } from '../../components/AlertRecipientsPanel'

/**
 * Who to tell when a scheduled run fails.
 *
 * @remarks
 * The same panel that used to sit below the Run Console, rendered under the configuration
 * path. Recipients are per organization and set once; the Run Console is where somebody
 * watches a run they started themselves, which is precisely the case where nobody needs
 * to be told.
 */
export function AlertSettings() {
  return <AlertRecipientsPanel />
}
